<template>
  <div class="users-nested">
    <section class="name">
      <div :class="`tree-header`">
        <h1>{{$t('message.generics.message.name')}}</h1>
      </div>

      <vue-nestable v-model="listData"
                    :maxDepth="20"
                    :threshold="10"
                    class="user-nested"
                    v-if="hasData">

        <div class="item"
             slot-scope="{ item }">

          <user-table-item-infos :user="item" />
        </div>

        <div slot="placeholder"></div>
      </vue-nestable>
    </section>

    <section class="permissions"
             :class="{ 'permissions_empty': !hasData }">
      <div class="header">
        <div class="header-item"
             v-for="(item, index) in permissionsList"
             :key="index">
          <h1 class="header-item-title"
              v-html="item.label"></h1>
        </div>
      </div>

      <vue-nestable v-model="listData"
                    v-if="hasData"
                    :maxDepth="0"
                    :threshold="30"
                    class="no-gutter-list">
        <div class="item"
             slot-scope="{ item }">
          <div class="toggle-list">
            <div v-for="(permission, index) in permissionsList"
                 :key="index"
                 class="toogle-list-item">
              <toggle class="toggle"
                      :disabled="!isMaster(item) && isPermissionReservedToMaster(permission.key)"
                      :tooltip="returnPermissionRestrictToMasterTooltip(item, permission)"
                      :value="isMaster(item) ? true : hasPermission(permission.key, item.permissions)"
                      @input="isMaster(item) ? null : permissionChange({item: item, permission: permission.key, value: $event})"></Toggle>
            </div>
          </div>
        </div>
        <div slot="placeholder"></div>

      </vue-nestable>
    </section>

    <section class="actions-list"
             v-if="hasData">
      <vue-nestable v-model="listData"
                    :maxDepth="20"
                    :threshold="30"
                    class="no-gutter-list">

        <div class="item"
             slot-scope="{ item }">
          <div class="action"
               v-if="!isSubAdmin">
            <template v-if="!isMaster(item)">
              <i v-if="isAdmin"
                 class="mdi mdi-arrow-up-bold-outline"
                 v-tooltip="$t('message.users.message.becomeMaster')"
                 @click="showMasterModal(item)"></i>

              <i v-if="item.isBlocked"
                 class="mdi mdi-lock-open pointer"
                 v-tooltip="$t('message.users.message.unblock')"
                 @click="unlockLogin(item)"></i>

              <i v-if="!isMaster(item) && isEstabelecimento"
                 class="mdi mdi-link-variant pointer"
                 v-tooltip="$t('message.users.message.linkSpots')"
                 @click="openLocalAssingModal(item)"></i>

              <i class="mdi mdi-square-edit-outline pointer"
                 v-tooltip="$t('message.generics.message.edit')"
                 @click="openEditModal(item)">
              </i>
              <i class="mdi mdi-close-circle-outline"
                 v-tooltip="$t('message.generics.message.delete')"
                 @click="showDeleteModal(item)"></i>
            </template>

          </div>

        </div>
        <div slot="placeholder"></div>

      </vue-nestable>
    </section>

    <users-creation-modal v-if="userToEdit"
                          ref="editUserModal"
                          :user="userToEdit"
                          @alter-permission="alterPermission('READ_CLIENT_DATA', userToEdit)"
                          @updated="reloadTable" />

    <users-local-assign-modal ref="localAssignModal"
                              :user="userToEdit" />

    <confirmation-modal :value="showMasterConfirmModal"
                        :confirm-label="$t('message.generics.message.confirm')"
                        @confirm="changeToMasterUser"
                        @cancel="() => showMasterConfirmModal = false">
      <span slot="heading">
        {{$t('message.users.message.makeUserMaster')}}
      </span>
      <span>
        {{$t('message.users.message.makeUserMasterConfirmation')}}
      </span>
    </confirmation-modal>

    <confirmation-modal :value="showDeleteConfirmModal"
                        :confirm-label="$t('message.generics.message.confirm')"
                        @confirm="deleteNode"
                        @cancel="() => showDeleteConfirmModal = false">
      <span slot="heading">
        {{$t('message.users.message.deleteUser')}}
      </span>
      <span>
        {{$t('message.users.message.deleteUserConfirmation')}}
      </span>
    </confirmation-modal>

    <confirmation-modal :value="showPermissionDeleteConfirmModal"
                        :confirm-label="$t('message.generics.message.confirm')"
                        @confirm="alterPermission(permissionData.permission, permissionData.item)"
                        @cancel="() => showPermissionDeleteConfirmModal = false">
      <span slot="heading">
        {{$t('message.users.message.revokePermission')}}
      </span>
      <span>
        {{$t('message.users.message.revokePermissionConfirmation')}}
      </span>
    </confirmation-modal>

  </div>
</template>

<script>
import ConfirmationModal from "@components/ConfirmationModal";
import UsersCreationModal from "@views/users/components/UsersCreationModal";
import UserTableItemInfos from "@views/users/components/UserTableItemInfos";
import Toggle from "@components/Toggle";
import { VueNestable } from "vue-nestable";
import EventBus from "@packages/event-bus";
import UsersLocalAssignModal from "@views/users/components/UsersLocalAssignModal.vue";
import jwtDecode from "jwt-decode";

export default {
  props: {
    list: {
      type: Array,
    },
    allowDrag: {
      type: Boolean,
      default: true,
    },
  },

  components: {
    Toggle,
    VueNestable,
    UsersLocalAssignModal,
    UserTableItemInfos,
    UsersCreationModal,
    ConfirmationModal,
  },

  data() {
    return {
      userToMaster: undefined,
      userToDelete: undefined,
      userToEdit: undefined,
      isActive: false,
      permissionsList: [],
      moveData: {
        isMoving: false,
        pathFrom: undefined,
        dragItem: undefined,
      },
      listData: this.list.map((item) => {
        return {
          ...item,
          permissions: item.permissions,
        };
      }),

      showMasterConfirmModal: false,
      showDeleteConfirmModal: false,
      permissionData: {
        item: undefined,
        permission: undefined,
      },
      possiblePermissions: {},
      showPermissionDeleteConfirmModal: false,
    };
  },
  async created() {
    this.loadPermissions();
    EventBus.$on("LOCALE_CHANGED", this.loadPermissions);
  },

  watch: {
    list: function (val) {
      this.listData = val.map((item) => {
        return {
          ...item,
          permissions: item.permissions,
        };
      });
    },
  },

  computed: {
    hasData() {
      return this.listData && this.listData.length;
    },
    isEstabelecimento() {
      if (this.$store.state.users.user == null) {
        return false;
      }
      return this.$store.state.users.user.tipo === "ESTABELECIMENTO";
    },
    isAdmin() {
      return !!this.$store.state.users.admin;
    },
    user() {
      return !!this.$store.state.users.user;
    },
    isSubAdmin() {
      if (this.isAdmin && this.$store.state.users.user == null) {
        const tokenAdmin = this.$store.state.users.admin.token;
        const decodedToken = jwtDecode(tokenAdmin);
        return decodedToken.userId !== decodedToken.masterId;
      }
      return false;
    },
    
  },

  methods: {
    async loadPermissions() {
      const permissions = await this.$api.userLogin.listPermissions();

      this.possiblePermissions = permissions;

      this.permissionsList = permissions;
    },
    isMaster(item) {
      return item.id === item.masterId;
    },
    isPermissionReservedToMaster(key) {      
      return (key === "CUSTOMIZE_USE_TERMS" || key === "DISABLE_PLATFORM_USE_TERMS" || key === "MANAGE_PLATFORM_API") ? true : false
    },
    async deleteNode() {
      try {
        await this.$api.userLogin.delete({ id: this.userToDelete });

        this.removeNode({ id: this.userToDelete });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t("message.successMessages.message.userDeleted"),
          timeout: 2000,
        });

        this.showDeleteConfirmModal = false;
      } catch (error) {
        console.log(error);
      }
    },
    async changeToMasterUser() {
      try {
        const userData = await this.$api.userLogin.changeMaster({
          id: this.userToMaster,
        });

        localStorage.setItem("token", userData.token);

        const resulToken = jwtDecode(userData.token);

        this.$store.commit("SET_TOKEN", userData.token);

        this.$store.commit("SET_USER", {
          avatar: userData.avatar,
          id: resulToken.loggedAs.userId,
          login: resulToken.loggedAs.sub,
          nome: resulToken.loggedAs.userName,
          permissions: resulToken.loggedAs.permissions,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t("message.successMessages.message.userMaster"),
          timeout: 2000,
        });

        this.showMasterConfirmModal = false;
        this.listData = this.listData.map((user) => {
          user.masterId = resulToken.loggedAs.userId;
          return user;
        });

        location.reload();
      } catch (error) {
        console.log(error);
      }
    },
    showMasterModal(item) {
      this.userToMaster = item.id;
      this.showMasterConfirmModal = true;
    },
    showDeleteModal(item) {
      this.userToDelete = item.id;
      this.showDeleteConfirmModal = true;
    },
    reloadTable() {
      EventBus.$emit("RELOAD_USER_TABLE");
    },
    openEditModal(item) {
      const pathTo = this.getPathByIdentifier(item.id);
      const parent = this.getDragParent({ pathTo });

      this.userToEdit = { ...item, parentId: parent.id };

      this.$nextTick(() => {
        this.$refs.editUserModal.edit();
      });
    },
    openLocalAssingModal(item) {
      this.userToEdit = item;

      this.$nextTick(() => {
        this.$refs.localAssignModal.edit();
      });
    },
    async unlockLogin(item) {
      const res = await this.$api.auth.unlockLogin({ id: item.id });

      item.isBlocked = false;

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: res.message,
        timeout: 2000,
      });
    },
    getDragParent({ pathTo }) {
      let dragParent = this.listData[pathTo[0]];

      for (let index = 1; index < pathTo.length - 1; index++) {
        dragParent = dragParent.children[pathTo[index]];
      }

      return dragParent;
    },
    checkMoveHandler({ pathFrom, dragItem }) {
      if (!this.moveData.isMoving) {
        this.moveData.isMoving = true;
        this.moveData.pathFrom = pathFrom;
        this.moveData.dragItem = dragItem;
      }

      return true;
    },
    removeNode({ id }) {
      const path = this.getPathByIdentifier(id, this.listData);

      const nodeParent = this.getDragParent({ pathTo: path });

      if (nodeParent && nodeParent.id !== id) {
        const index = nodeParent.children.findIndex((node) => {
          return node.id === id;
        });

        if (index > -1) {
          return nodeParent.children.splice(index, 1);
        }
      } else if (!nodeParent || nodeParent.id === id) {
        const index = this.listData.findIndex((node) => {
          return node.id === id;
        });

        if (index > -1) {
          return this.listData.splice(index, 1);
        }
      }
    },
    getPathByIdentifier(id, items = this.listData) {
      let path = [];

      items.every((item, i) => {
        if (item["id"] === id) {
          path.push(i);
        } else if (item.children) {
          const childrenPath = this.getPathByIdentifier(id, item.children);

          if (childrenPath.length) {
            path = path.concat(i).concat(childrenPath);
          }
        }

        return path.length === 0;
      });

      return path;
    },
    permissionChange(permissionData) {
      this.permissionData = permissionData;

      if (permissionData.value) {
        this.alterPermission(
          this.permissionData.permission,
          this.permissionData.item
        );
      } else {
        this.showPermissionDeleteConfirmModal = true;
      }
    },
    async alterPermission(permission, item) {
      try {
        const res = await this.$api.userLogin.alterPermission({
          userId: item.id,
          permission,
        });

        if (!item.permissions) {
          item.permissions = [];
        }

        if (res) {
          item.permissions.push(permission);
          if(permission === "CREATE_CAMPAIGN" && !item.permissions.includes("READ_CAMPAIGN")) {
            await this.$api.userLogin.alterPermission({
              userId: item.id,
              permission: "READ_CAMPAIGN"
            })
            item.permissions.push("READ_CAMPAIGN");
          }
        } else {
          const permissionIndex = item.permissions.findIndex(
            (savedPermission) => savedPermission === permission
          );

          item.permissions.splice(permissionIndex, 1);
          if(permission === "READ_CAMPAIGN" && item.permissions.includes("CREATE_CAMPAIGN")) {
            await this.$api.userLogin.alterPermission({
              userId: item.id,
              permission: "CREATE_CAMPAIGN"
            })
            item.permissions = item.permissions.filter(permission => permission !== "CREATE_CAMPAIGN")
          }
        }

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t("message.successMessages.message.permissionChanged"),
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.showPermissionDeleteConfirmModal = false;
      }
    },
    hasPermission(role, permissions) {
      return !!permissions && permissions.includes(role);
    },
    returnPermissionRestrictToMasterTooltip(item, permission) {      
      if(!this.isMaster(item) && this.isPermissionReservedToMaster(permission.key)) {
        return this.$t("message.users.message.permissionsRestrictToMaster")
      } else {
        return ''
      }
      
    }
  },
};
</script>

<style scoped lang="scss">
.users-nested {
  display: flex;

  &::v-deep .nestable-list {
    padding: 0;
  }

  .name {
    width: 250px;
  }

  .permissions {
    width: calc(100% - 220px - 80px);
    overflow-x: auto;
    padding-top: 1px;

    .header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #c8c8c8;
      height: 48px;

      .header-item {
        width: 220px;
        height: 48px;
        padding-right: 20px;
        padding-bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        border-bottom: 1px solid #c8c8c8;
        margin-bottom: -1px;

        .header-item-title {
          line-height: 1.3;
          flex-shrink: 0;
          white-space: normal;
          font-size: 14px;
          max-width: 100%;
        }

        &:first-child {
          padding-left: 20px;
          width: 205px;
        }
      }
    }

    .item {
      width: 100%;

      .toggle-list {
        display: flex;
        height: 55px;
        width: 100%;
        border-bottom: 1px solid #c8c8c8;

        .toogle-list-item {
          height: 55px;
          padding-right: 20px;
          flex-shrink: 0;
          flex-basis: 220px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #c8c8c8;

          &:first-child {
            padding-left: 20px;
            flex-basis: 205px;
          }
        }
      }
    }

    h1 {
      font-weight: 600;
      font-size: 15px;
      text-align: center;
    }
  }

  .actions-list {
    width: 100px;
    margin-top: 49px;

    .action {
      flex: 1;
      display: flex;
      align-items: center;
      height: 55px;
      border-bottom: 1px solid #c8c8c8;
      cursor: pointer;
      padding-left: 10px;

      i {
        margin-right: 10px;
      }
    }
  }
}

.item {
  display: flex;

  .nestable-handle {
    display: flex;
    align-items: center;
    font-size: 24px;
  }

  .locale-table-item {
    flex: 1;
  }
}

.tree-header {
  border-bottom: 1px solid #c8c8c8;
  margin-left: 0;

  h1 {
    padding-bottom: 15px;
    font-weight: 600;
    font-size: 15px;
  }

  &.tree-header_drag {
    margin-left: 24px;
  }
}

::-webkit-scrollbar {
  height: 8px;
}
</style>
